import React from "react";
import { Alert, AlertProps } from "@emisgroup/ui-alert";

interface CustomAlertProps {
  /**
   * Children to render
   */
  children?: React.ReactNode;
}

type AltProps = AlertProps & CustomAlertProps;

/**
 * Responsible for rendering the alert component
 * @returns alert elements
 */
export const UIAlert: React.FC<AltProps> = (props: AltProps) => {

  const { children } = props;

  return (
    <Alert
      {...props}
    >
      {children}
    </Alert>
  );
};
